import { SolutionService } from './../../../service/solution.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Environment, Solution } from 'src/app/model/SolutionInfo';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { FormMode, FormObjectType } from '../../solution-form/solution-form.component';
import { catchError, of, tap } from 'rxjs';

export enum SolutionSaveResultType {
  CANCEL,
  SUCCESS,
  FAILURE
}

export class SolutionSaveResult {
  type: SolutionSaveResultType;
  form: FormGroup;
}

@Component({
    selector: 'app-solution',
    templateUrl: './solution.component.html',
    styleUrls: ['./solution.component.css'],
    standalone: false
})
export class SolutionComponent implements OnInit {

  FormMode = FormMode;
  FormObjectType = FormObjectType;

  //input
  mode: FormMode;
  type: FormObjectType;
  selectedSolution: Solution;
  selectedEnvironment: Environment;
  objectForm:FormGroup = new FormGroup({});
  
  title:string = '';
  primaryButtonId:string = '';
  primaryButton:string = '';
  result:SolutionSaveResult = {type: SolutionSaveResultType.CANCEL, form: this.objectForm};

  constructor(private modalRef: ModalRef,
              public modalConfig: ModalConfig,
              private solSrv: SolutionService) { }

  get nameCtrl() { return this.objectForm.get('nameCtrl'); }
  get descriptionCtrl() { return this.objectForm.get('descriptionCtrl'); }

  ngOnInit(): void {
    this.mode = this.modalConfig.data.mode;
    this.type = this.modalConfig.data.type;
    this.selectedSolution = this.modalConfig.data.selectedSolution;
    this.selectedEnvironment = this.modalConfig.data.selectedEnvironment;

    if(this.mode == FormMode.ADD){
      if(this.type == FormObjectType.SOLUTION){
        this.title = $localize`Add solution`;
      }else if(this.type == FormObjectType.ENVIRONMENT){
        this.title = $localize`Add environment`;
      }
      this.primaryButtonId = 'add-btn';
      this.primaryButton = $localize`Add`;
    }else if(this.mode == FormMode.EDIT){
      if(this.type == FormObjectType.SOLUTION){
        this.title = $localize`Edit solution - ${this.selectedSolution.name}`;
      }else if(this.type == FormObjectType.ENVIRONMENT){
        this.title = $localize`Edit environment - ${this.selectedEnvironment.name}`;
      }
      this.primaryButtonId = 'save-btn';
      this.primaryButton = $localize`Save`;
    }
  }

  updateSolutionForm(objectForm:FormGroup): void {
    this.objectForm = objectForm;
  }

  save(): void {
    if(this.type == FormObjectType.SOLUTION){
      this.solSrv.updateSolution(this.selectedSolution.name, this.nameCtrl.value, this.descriptionCtrl.value).pipe(
        tap(() => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.SUCCESS;
          this.modalRef.close(this.result);
        }),
        catchError(resp => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.FAILURE;
          this.modalRef.close(this.result);
          return of(resp);
        })
      ).subscribe();
    }else if(this.type == FormObjectType.ENVIRONMENT){
      this.solSrv.updateEnvironment(this.selectedEnvironment.id, this.nameCtrl.value, this.descriptionCtrl.value).pipe(
        tap(() => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.SUCCESS;
          this.modalRef.close(this.result);
        }),
        catchError(resp => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.FAILURE;
          this.modalRef.close(this.result);
          return of(resp);
        })
      ).subscribe();
    }
  }

  add(): void {
    if(this.type == FormObjectType.SOLUTION){
      this.solSrv.addSolution(this.nameCtrl.value, this.descriptionCtrl.value).pipe(
        tap(() => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.SUCCESS;
          this.modalRef.close(this.result);
        }),
        catchError(resp => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.FAILURE;
          this.modalRef.close(this.result);
          return of(resp);
        })
      ).subscribe();
    }else if(this.type == FormObjectType.ENVIRONMENT){
      this.solSrv.addEnvironment(this.nameCtrl.value, this.descriptionCtrl.value, this.selectedSolution.name).pipe(
        tap(() => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.SUCCESS;
          this.modalRef.close(this.result);
        }),
        catchError(resp => {
          this.result.form = this.objectForm;
          this.result.type = SolutionSaveResultType.FAILURE;
          this.modalRef.close(this.result);
          return of(resp);
        })
      ).subscribe();
    }
  }

  submit(): void {
    if(this.mode == FormMode.EDIT){
      this.save();
    }else if(this.mode == FormMode.ADD){
      this.add();
    }
  }

  cancel(): void {
    this.result.form = this.objectForm;
    this.result.type - SolutionSaveResultType.CANCEL;
    this.modalRef.close(this.result);
  }
}